export default "__VITE_ASSET__DhW87_Cu__"